<!-- State 1 & 2 & 4: Email, OTP, Active (all except status) -->
<button type="button" class="close unregistered-modal-close" aria-label="Close" (click)="activeModal.dismiss()">
  <span aria-hidden="true">&times;</span>
</button>
<ng-container *ngIf="step !== 'status'">
  <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
    <div *ngIf="step === 'email'" class="tw-flex tw-w-full tw-flex-col tw-items-center tw-rounded-2xl tw-border tw-border-gray-100 tw-bg-white tw-px-4 tw-pt-10 tw-shadow-sm">
      <div class="red-active tw-mb-4 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full">
        <lucide-icon name="mail" class="red-active" size="24"></lucide-icon>
      </div>
      <h3 class="tw-mb-2 tw-text-3xl tw-font-bold tw-text-[#1A1A1A]">{{ 'unregisteredModal.submitECFApplication' | translate }}</h3>
      <p class="tw-mb-2 tw-text-sm tw-text-gray-500">{{ 'unregisteredModal.enterEmail' | translate }}</p>

      <div class="tw-w-full">
        <div class="card-body tw-px-8 tw-pt-4">
          <div class="form-group">
            <label for="unregistered-email" class="tw-mb-2 tw-text-sm tw-font-semibold tw-text-gray-700">{{ 'unregisteredModal.emailAddress' | translate }}</label>
            <input id="unregistered-email"
              type="email"
              class="form-control tw-h-12 tw-rounded-lg tw-border-2 tw-border-gray-300 focus:tw-border-red-600 focus:tw-ring-0 focus:tw-shadow-none"
              [ngModel]="email"
              [placeholder]="'common.emailPlaceholder' | translate"
              (ngModelChange)="onEmailChange($event)"
              (keyup.enter)="submitEmail('continue')"
              [style.outline]="email?.trim() ? (isEmailValid ? '2px solid #22C55E' : '2px solid #EF4444') : 'none'"
              [style.outline-offset]="'2px'"
            />

            <div *ngIf="emailErrorKey" class="tw-mt-1 tw-text-xs tw-text-red-500">
              {{ emailErrorKey | translate }}
            </div>
          </div>

          <div class="tw-mb-6 tw-flex tw-gap-4">
            <button class="btn btn-outline-secondary tw-flex tw-h-12 tw-flex-1 tw-items-center tw-justify-center tw-gap-2 tw-border-gray-300 tw-font-semibold tw-text-gray-600" (click)="submitEmail('check')" [disabled]="isLoading || !isEmailValid">
              <lucide-icon name="search" size="18"></lucide-icon>
              {{ 'unregisteredModal.checkStatus' | translate }}
            </button>
            <button class="btn btn-primary btn-colour primary red tw-flex tw-h-12 tw-flex-1 tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-border-[#E83E48] tw-bg-[#E83E48] tw-font-semibold" (click)="submitEmail('continue')" [disabled]="isLoading || !isEmailValid">
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
              {{ 'common.continue' | translate }} &rarr;
            </button>
          </div>

          <div class="tw-relative tw-flex tw-items-center tw-py-4">
            <div class="tw-flex-grow tw-border-t tw-border-gray-200"></div>
            <span class="tw-mx-4 tw-flex-shrink-0 tw-text-sm tw-text-gray-400">{{ 'unregisteredModal.alreadySubmitted' | translate }}</span>
            <div class="tw-flex-grow tw-border-t tw-border-gray-200"></div>
          </div>

          <p class="tw-mt-2 tw-text-center tw-text-xs tw-text-gray-500">
            {{ 'unregisteredModal.enterEmailAbove' | translate }}
          </p>
        </div>
      </div>
    </div>

    <ng-container *ngIf="step === 'otp'">
      <div class="tw-flex tw-w-full tw-max-w-[500px] tw-flex-col tw-items-center tw-rounded-2xl tw-border tw-border-gray-100 tw-bg-white tw-p-8 tw-shadow-sm">
        <div class="blue-active tw-mb-4 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full">
          <lucide-icon name="shield-check" class="blue-active" size="24"></lucide-icon>
        </div>
        <h3 class="tw-mb-2 tw-text-3xl tw-font-bold tw-text-[#1A1A1A]">{{ 'unregisteredModal.verifyYourEmail' | translate }}</h3>
        <p class="tw-mb-6 tw-text-center tw-text-sm tw-text-gray-500" [innerHTML]="'unregisteredModal.sentDigitCodeTo' | translate: { email: escapedEmail }">
        </p>

      <div class="card tw-mb-3 tw-w-full tw-border-gray-200 tw-shadow-sm">
          <div class="card-body tw-p-8">
            <div class="form-group tw-mb-2">
              <label for="unregistered-otp" class="tw-mb-2 tw-text-sm tw-font-semibold tw-text-gray-700">{{ 'unregisteredModal.verificationCode' | translate }}</label>
              <input id="unregistered-otp"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                maxlength="6"
                class="form-control tw-h-12 tw-border-gray-300 tw-text-center tw-text-xl tw-font-semibold tw-tracking-[0.5em] focus:tw-border-[#E83E48] focus:tw-ring-[#E83E48]"
                [(ngModel)]="otp"
                placeholder="1 2 3 4 5 6"
                (keyup.enter)="otp?.length === 6 && verifyOtp()"
              />
            </div>
            <p class="tw-mb-6 tw-mt-2 tw-text-center tw-text-xs tw-text-gray-400">{{ 'unregisteredModal.enterCodeFromEmail' | translate }}</p>

            <button class="btn btn-primary tw-mb-4 tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-border-[#E83E48] tw-bg-[#E83E48] tw-font-semibold tw-opacity-90 hover:tw-bg-[#d63440]" (click)="verifyOtp()" [disabled]="!otp || otp.length !== 6 || isLoading">
              <i *ngIf="isLoading" class="fa fa-circle-o-notch fa-spin tw-mr-2"></i>
              {{ 'raise.verifyEmail' | translate }}
            </button>

            <div class="tw-text-center">
              <button class="tw-inline-flex tw-items-center tw-justify-center tw-gap-1 tw-border-0 tw-bg-transparent tw-p-0 tw-text-sm tw-font-semibold tw-text-gray-400 tw-no-underline tw-transition-all enabled:hover:-tw-translate-y-0.5 enabled:hover:tw-text-gray-600 disabled:tw-cursor-not-allowed" (click)="resendOtp()" [disabled]="isLoading || countdown > 0">
                <i class="fa fa-refresh tw-mr-1" [class.fa-spin]="countdown > 0"></i>
                {{ (countdown > 0 ? 'unregisteredModal.resendInSeconds' : 'unregisteredModal.resend') | translate: { seconds: countdown } }}
              </button>
            </div>
          </div>
        </div>

        <button class="tw-bg-transparent tw-font-semibold tw-text-gray-500 tw-no-underline tw-transition-all hover:-tw-translate-y-0.5 hover:tw-text-gray-700" (click)="step = 'email'">
          &larr; {{ 'unregisteredModal.changeEmailAddress' | translate }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 'emailExisting'">
      <div class="tw-flex tw-w-full tw-flex-col tw-items-center">
        <div class="tw-flex tw-w-full tw-max-w-[500px] tw-flex-col tw-items-center tw-rounded-2xl tw-border tw-border-gray-100 tw-bg-white tw-p-8 tw-shadow-sm">
          <div class="blue-active tw-mb-4 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full">
            <lucide-icon name="info" class="blue-active" size="24"></lucide-icon>
          </div>
          <h3 class="tw-mb-2 tw-text-center tw-text-3xl tw-font-bold tw-text-[#1A1A1A]">{{ 'unregisteredModal.accountActive' | translate }}</h3>
          <p class="tw-mb-6 tw-text-center tw-text-gray-500">
            {{ 'unregisteredModal.emailAlreadyRegistered' | translate }}
          </p>

          <button class="btn btn-primary btn-colour primary red tw-mb-3 tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-border-[#E83E48] tw-bg-[#E83E48] tw-font-semibold hover:tw-bg-[#d63440]" (click)="goToLogin()">
            {{ 'unregisteredModal.goToLogin' | translate }}
          </button>

          <button class="tw-border-0 tw-bg-transparent tw-text-sm tw-font-semibold tw-text-[#E83E48] hover:tw-text-[#d63440]" (click)="goToForgotPassword()">
            {{ 'unregisteredModal.forgotPassword' | translate }}
          </button>
        </div>

        <button class="tw-mt-3 tw-inline-flex tw-items-center tw-gap-2 tw-border-0 tw-bg-transparent tw-font-semibold tw-text-gray-500 tw-no-underline hover:tw-text-gray-700" (click)="step = 'email'">
          &larr; {{ 'unregisteredModal.backToEmailCheck' | translate }}
        </button>
      </div>
    </ng-container>
  </div>

  <div *ngIf="step === 'email'" class="tw-mt-3 tw-flex tw-w-full tw-justify-center">
    <button class="tw-inline-flex tw-items-center tw-gap-2 tw-border-0 tw-bg-transparent tw-font-semibold tw-text-gray-500 tw-no-underline hover:tw-text-gray-700" (click)="activeModal.dismiss()">
      <lucide-icon name="move-left" size="16"></lucide-icon>
      {{ 'unregisteredModal.backToHome' | translate }}
    </button>
  </div>
</ng-container>

<!-- State 3: Application Status -->
<div *ngIf="step === 'status'" class="tw-flex tw-min-h-[400px] tw-w-full tw-flex-col tw-items-center tw-justify-center tw-py-10">
  <div class="tw-flex tw-w-full tw-max-w-[480px] tw-flex-col tw-items-center">
    <ng-container *ngIf="!submission">
      <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-rounded-2xl tw-border tw-border-gray-100 tw-bg-white tw-p-8 tw-shadow-sm">
        <div class="tw-mb-4 tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#E8F5E9]">
          <i class="fa fa-file-text-o tw-text-2xl tw-text-[#4CAF50]"></i>
        </div>
        <h3 class="tw-mb-3 tw-text-2xl tw-font-bold tw-text-[#1A1A1A]">{{ 'unregisteredModal.noApplicationFound' | translate }}</h3>
        <p class="tw-mb-8 tw-text-center tw-text-gray-500">
          {{ 'unregisteredModal.noExistingApplicationFound' | translate }}
        </p>
        <button class="btn btn-primary tw-mb-6 tw-h-12 tw-w-full tw-max-w-[360px] tw-border-[#E83E48] tw-bg-[#E83E48] tw-font-semibold hover:tw-bg-[#d63440]" (click)="goToSubmitApplication()">
          {{ 'unregisteredModal.submitNewApplication' | translate }}
        </button>
      </div>
      <div class="tw-mt-3 tw-text-center">
        <button class="tw-border-0 tw-bg-transparent tw-font-semibold tw-text-gray-500 tw-no-underline hover:tw-text-gray-700" (click)="step = 'email'">
          &larr; {{ 'unregisteredModal.backToEmailCheck' | translate }}
        </button>
      </div>
    </ng-container>

    <div *ngIf="submission" class="tw-w-full">
<div class="card tw-mb-3 tw-w-full tw-rounded-2xl tw-border-gray-200 tw-shadow-sm">
        <div class="card-body tw-flex tw-flex-col tw-items-center tw-p-8">
          <div class="tw-mb-4 tw-flex tw-h-16 tw-w-16 tw-items-center tw-justify-center tw-rounded-full"
               [ngClass]="{
                 'tw-bg-[#FFF9E6]': submission.status === UnregisteredSubmissionStatus.Pending,
                 'tw-bg-[#FFEBEE]': submission.status === UnregisteredSubmissionStatus.Rejected,
                 'tw-bg-[#E8F5E9]': submission.status === UnregisteredSubmissionStatus.Approved || submission.status === UnregisteredSubmissionStatus.ApprovedPendingActivation || submission.status === UnregisteredSubmissionStatus.Success
               }">
            <i class="fa tw-text-2xl"
               [ngClass]="{
                 'fa-clock-o tw-text-[#F9A825]': submission.status === UnregisteredSubmissionStatus.Pending,
                 'fa-times-circle-o tw-text-[#E53935]': submission.status === UnregisteredSubmissionStatus.Rejected,
                 'fa-check-circle-o tw-text-[#4CAF50]': submission.status === UnregisteredSubmissionStatus.Approved || submission.status === UnregisteredSubmissionStatus.ApprovedPendingActivation || submission.status === UnregisteredSubmissionStatus.Success
               }"></i>
          </div>

          <h3 class="tw-mb-2 tw-text-2xl tw-font-bold tw-text-[#1A1A1A]">
            <span *ngIf="submission.status === UnregisteredSubmissionStatus.Pending">{{ 'unregisteredModal.applicationPending' | translate }}</span>
            <span *ngIf="submission.status === UnregisteredSubmissionStatus.Rejected">{{ 'unregisteredModal.applicationRejected' | translate }}</span>
            <span *ngIf="submission.status === UnregisteredSubmissionStatus.Approved">{{ 'unregisteredModal.applicationApproved' | translate }}</span>
            <span *ngIf="submission.status === UnregisteredSubmissionStatus.ApprovedPendingActivation">{{ 'unregisteredModal.applicationApproved' | translate }}</span>
            <span *ngIf="submission.status === UnregisteredSubmissionStatus.Success">{{ 'unregisteredModal.accountActive' | translate }}</span>
          </h3>

          <span class="badge badge-pill tw-mb-4 tw-px-4 tw-py-1 tw-text-xs tw-uppercase"
                [ngClass]="statusBadgeClass[submission.status]">
            <span>{{ 'unregisteredStatus.' + UnregisteredSubmissionStatus[submission.status] | translate }}</span>
          </span>

          <p class="tw-mb-2 tw-text-center tw-text-gray-500">
            {{ 'unregisteredModal.foundExistingApplication' | translate }}
          </p>
          <p class="tw-mb-6 tw-text-center tw-font-semibold tw-text-[#1A1A1A]">
            {{ submission.createdAt | date: 'MMMM d, yyyy' }}.
          </p>

          <div *ngIf="submission.status === UnregisteredSubmissionStatus.Rejected && submission.rejectedReason" class="tw-mb-6 tw-w-full tw-rounded-lg tw-border tw-border-[#FFCDD2] tw-bg-[#FFF5F5] tw-p-4">
            <p class="tw-mb-0 tw-text-sm tw-text-[#E53935]">
              <strong>{{ 'raise.reason' | translate }}</strong> {{ submission.rejectedReason }}
            </p>
          </div>

          <button class="btn btn-primary tw-mb-3 tw-h-12 tw-w-full tw-border-[#E83E48] tw-bg-[#E83E48] tw-font-semibold hover:tw-bg-[#d63440]" (click)="viewMyApplication()">
            {{ 'unregisteredModal.viewMyApplication' | translate }}
          </button>

          <div class="tw-relative tw-flex tw-w-full tw-items-center tw-py-3">
            <div class="tw-flex-grow tw-border-t tw-border-gray-200"></div>
            <span class="tw-mx-4 tw-flex-shrink-0 tw-text-sm tw-text-gray-400">{{ 'unregisteredModal.or' | translate }}</span>
            <div class="tw-flex-grow tw-border-t tw-border-gray-200"></div>
          </div>

          <button *ngIf="submission.status !== UnregisteredSubmissionStatus.ApprovedPendingActivation && submission.status !== UnregisteredSubmissionStatus.Success" [disabled]="isSubmittingOverride" class="btn btn-outline-warning tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-border-[#F9A825] tw-font-semibold tw-text-[#F9A825] hover:tw-bg-[#FFF9E6]" (click)="submitNewApplicationOverride()">
            <i class="fa fa-exclamation-triangle"></i> {{ 'unregisteredModal.submitNewApplicationOverride' | translate }}
          </button>

          <button *ngIf="submission.status === UnregisteredSubmissionStatus.ApprovedPendingActivation" class="btn btn-outline-success tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-border-[#4CAF50] tw-font-semibold tw-text-[#4CAF50] hover:tw-bg-[#E8F5E9]" (click)="activateAccount()">
            <i class="fa fa-user-plus"></i> {{ 'signUp.activateAccount' | translate }}
          </button>
          <button *ngIf="submission.status === UnregisteredSubmissionStatus.Success"
                  class="btn btn-outline-success tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-border-[#4CAF50] tw-font-semibold tw-text-[#4CAF50] hover:tw-bg-[#E8F5E9]"
                  (click)="goToLogin()">
            {{ 'unregisteredModal.goToLogin' | translate }}
          </button>
        </div>
      </div>

      <div class="tw-text-center">
        <button class="tw-border-0 tw-bg-transparent tw-font-semibold tw-text-gray-500 tw-no-underline hover:tw-text-gray-700" (click)="step = 'email'">
          &larr; {{ 'unregisteredModal.backToEmailCheck' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
